export const SITE_ADDRESS = process.env.REACT_APP_URL;
export const WHATSAPP_ADDRESS = process.env.REACT_APP_WHATSAPP;
export const SCHOOL_NAME = 'SMPK Santa Maria 2 Malang'

// Delay Render
export const TIME_DELAY = 500;